import { StudentResultsStore } from "../../../react/students/StudentResultsStore"
import { KidsChoiceCategoryType, KidsChoiceHealthVideos, KidsChoiceSecondHandVideos, KidsChoiceVideoChoice } from "./KidsChoiceTypes"

export class KidsChoiceStore {
    private static innerInstance: KidsChoiceStore

    watchedHealthVideos = []
    watchedSecondhandVideos = []
    votedHealth?: KidsChoiceHealthVideos
    votedSecondhand?: KidsChoiceSecondHandVideos
    viewedHealthVotes: boolean
    viewedSecondhandVotes: boolean

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static newInstance() {
        return this.innerInstance = new this()
    }

    votedForVideo = (type: KidsChoiceCategoryType) => type === KidsChoiceCategoryType.HEALTH_EFFECTS ? this.votedHealth : this.votedSecondhand

    voteIsCast = (type: KidsChoiceCategoryType) => type === KidsChoiceCategoryType.HEALTH_EFFECTS ? this.votedHealth != null : this.votedSecondhand != null

    allWatched = (type: KidsChoiceCategoryType) => {
        if (type === KidsChoiceCategoryType.HEALTH_EFFECTS) {
            return this.watchedHealth
        } else {
            return this.watchedSecondhand
        }
    }

    get watchedHealth(): boolean {
        return this.watchedHealthVideos.length === 2
    }

    get watchedSecondhand(): boolean {
        return this.watchedSecondhandVideos.length === 2
    }

    addHealthVideo = (v: KidsChoiceVideoChoice) => {
        if (!this.watchedHealthVideos.includes(v)) {
            this.watchedHealthVideos.push(v)
        }
    }

    addSecondhandVideo = (v: KidsChoiceVideoChoice) => {
        if (!this.watchedSecondhandVideos.includes(v)) {
            this.watchedSecondhandVideos.push(v)
        }
    }

    static votesForVideo = (type: KidsChoiceCategoryType, video: KidsChoiceVideoChoice) => {
        if (type === KidsChoiceCategoryType.HEALTH_EFFECTS) {
            return KidsChoiceStore.votesForHealthVideo(video as KidsChoiceHealthVideos)
        } else {
            return KidsChoiceStore.votesForSecondHandVideo(video as KidsChoiceSecondHandVideos)
        }
    }

    static votesForHealthVideo = (video: KidsChoiceHealthVideos): number => {
        return StudentResultsStore.instance.findKidsChoiceSelections().filter(result => result.healthChoice === video).length
    }

    static votesForSecondHandVideo = (video: KidsChoiceSecondHandVideos) => {
        return StudentResultsStore.instance.findKidsChoiceSelections().filter(result => result.secondHandChoice === video).length
    }

    static votedFor = (type: KidsChoiceCategoryType) => type === KidsChoiceCategoryType.HEALTH_EFFECTS
        ? KidsChoiceStore.getStudentsVotes().healthChoice : KidsChoiceStore.getStudentsVotes().secondHandChoice

    static getStudentsVotes = () => {
        const selections = StudentResultsStore.instance.currentStudentResults.kidsChoiceSelections
        if (selections == null) {
            return {
                healthChoice: undefined,
                secondHandChoice: undefined
            }
        }
        return selections
    }
}
